/**
 * API/DB 아이콘 문자열을 화면 표시용 class + Material 텍스트로 변환
 * - FontAwesome: "fas fa-cogs"
 * - Material shorthand: "material wb_incandescent"
 * - Material full: "material-icons wb_incandescent"
 */
export function isMaterialIconString(icon) {
    if (!icon || !String(icon).trim()) return false;
    const raw = String(icon).trim();
    if (raw.split(/\s+/)[0] === "material") return true;
    return raw.includes("material-icons");
}

/** API 축약형 "fa-cog" 등을 "fas fa-cog"로 보정 (데이터 수집 트리 등) */
export function normalizeFontAwesomeIconString(icon) {
    if (!icon || !String(icon).trim()) return icon;
    const raw = String(icon).trim();
    if (isMaterialIconString(raw)) return raw;

    const parts = raw.split(/\s+/);
    if (parts.length === 1 && /^fa-/.test(parts[0])) {
        return `fas ${parts[0]}`;
    }
    return raw;
}

export function resolveIconDisplay(icon, fallback = "fas fa-cog") {
    if (!icon || !String(icon).trim()) {
        return { iconClass: fallback, iconText: "" };
    }
    const raw = normalizeFontAwesomeIconString(String(icon).trim());
    const parts = raw.split(/\s+/);
    if (parts[0] === "material") {
        return {
            iconClass: "material-icons",
            iconText: parts.slice(1).join(" "),
        };
    }
    if (raw.includes("material-icons")) {
        const materialClassMatch = raw.match(/^(material-icons[-\w]*)/);
        const iconClass = materialClassMatch ? materialClassMatch[0] : "material-icons";
        const iconText = raw.replace(/material-icons[-\w]*/g, "").trim();
        return { iconClass, iconText };
    }
    return { iconClass: raw, iconText: "" };
}

export function getEquipTypeIconFromStore(store, equipTypeCode, fallback = "fas fa-cog") {
    const list = store?.state?.equipTypeList || [];
    const found = list.find((item) => item.equipType === equipTypeCode);
    return found?.icon || fallback;
}
